import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import { PATH_WORKFLOW_LIBRARY_ASSETS } from '@/lib/constants/api'
import buildInitialState from '@/store/helpers/buildInitialState'
import updateStatus from '@/store/helpers/updateStatus'
import { notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const workflowLibraryAssets = {
  namespaced: true,
  state: buildInitialState({
    workflowLibraryAssetList: []
  }),
  getters: {
    getField
  },
  actions: {
    getWorkflowLibraryAssets ({ commit, dispatch }, filters = {}) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Loading assets, please wait...' })

      return api.doGet({ path: PATH_WORKFLOW_LIBRARY_ASSETS, parameters: filters })
        .then(json => json.data)
        .then(assets => {
          commit('updateStatus', { status: COMPLETE })
          commit('setWorkflowLibraryAssets', assets)
          return assets
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to load assets')
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    }
  },
  mutations: {
    updateStatus,
    updateField,
    setWorkflowLibraryAssets (state, assets) {
      state.workflowLibraryAssetList = assets
    }
  }
}

export default workflowLibraryAssets
